import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import Dialog from "components/DesignComponents/Dialog";
import QueryDropdown from "components/QueryDropdown";
import {
    DialogHandler,
    DROPDOWN_SIZES,
    ENDPOINTS,
    FILTER_NAMES,
    ID_TYPE,
    maxDialogWidth,
    useMediaQueries
} from "shared";

import Actions from "./Actions";
import { useTctWebDialog } from "./hooks";
import { STEPS } from "./types";

const TctWebDialog = ({ isOpen, close }: DialogHandler) => {
    const { t } = useTranslation();
    const { toMd, fromMd } = useMediaQueries();

    const {
        isLoading,
        hasNoPermission,
        isEditDisabled,
        isInitialStep,
        selectedConfiguration,
        setStep,
        setSelectedConfiguration,
        handleStep,
        handleFileChange,
        handleSubmitCreate,
        handleSubmitEdit
    } = useTctWebDialog(isOpen, close);

    return (
        <Dialog
            open={isOpen}
            close={close}
            title={
                isInitialStep
                    ? t("Tct##open tct")
                    : t("Tct##edit configuration")
            }
            description={
                isInitialStep
                    ? t("Tct##open tct description")
                    : t("Tct##select configuration file")
            }
            isTitleSeparator
            isActionsSeparator={!isInitialStep}
            slotProps={{
                transition: {
                    onExited: () => {
                        setStep(STEPS.Initial);
                        setSelectedConfiguration(null);
                    }
                }
            }}
            actions={
                <Actions
                    isLoading={isLoading}
                    hasNoPermission={hasNoPermission}
                    isEditDisabled={isEditDisabled}
                    isInitialStep={isInitialStep}
                    selectedConfiguration={selectedConfiguration}
                    setSelectedConfiguration={setSelectedConfiguration}
                    handleStep={handleStep}
                    handleSubmitCreate={handleSubmitCreate}
                    handleSubmitEdit={handleSubmitEdit}
                />
            }
            css={css(fromMd && maxDialogWidth)}
            extendToMaxWidth={toMd}
        >
            {isInitialStep ? null : (
                <QueryDropdown
                    resource={`${ENDPOINTS.Files}?${FILTER_NAMES.WebEditorSupport}=true`}
                    idType={ID_TYPE.Id}
                    size={DROPDOWN_SIZES.Medium}
                    fullWidth
                    value={selectedConfiguration}
                    change={(_, val) => handleFileChange(val)}
                    labelLeft="Select file"
                    textFieldParams={{
                        placeholder: t("Dialog##select")
                    }}
                    customStyle={{ marginBottom: "8px" }}
                    isRequired
                    isRootRequired
                />
            )}
        </Dialog>
    );
};

export default TctWebDialog;
